"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchFolders = exports.fetchFolderWithBreadcrumbs = exports.fetchSingleFolder = void 0;

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var _Api = require("../constants/Api");

var _pick = _interopRequireDefault(require("../utils/pick"));

var BASE_URI = 'filemanager/api/v2/folders';
var BASE_URI_V3 = 'filemanager/api/v3/folders';
var DEFAULT_QUERY = {
  deleted_at: 0,
  order_by: 'name',
  offset: 0,
  limit: _Api.FOLDER_BY_PARENT_REQUEST_LIMIT
};
var PASSTHROUGH_QUERY_PARAMS = ['offset', 'limit', 'parent_folder_id', 'hostApp'];

var buildQueryObject = function buildQueryObject(options) {
  var query = Object.assign({}, DEFAULT_QUERY, {}, (0, _pick.default)(options, PASSTHROUGH_QUERY_PARAMS));

  if (options.search) {
    query.name__icontains = options.search;
  }

  return query;
};

var fetchSingleFolder = function fetchSingleFolder(folderId) {
  return _apiClient.default.get(BASE_URI + "/" + folderId);
};

exports.fetchSingleFolder = fetchSingleFolder;

var fetchFolderWithBreadcrumbs = function fetchFolderWithBreadcrumbs(folderIdOrPath) {
  return _apiClient.default.get(BASE_URI_V3 + "/breadcrumbs/" + folderIdOrPath);
};

exports.fetchFolderWithBreadcrumbs = fetchFolderWithBreadcrumbs;

var fetchFolders = function fetchFolders() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _apiClient.default.get(BASE_URI, {
    query: buildQueryObject(options)
  });
};

exports.fetchFolders = fetchFolders;